import { render, staticRenderFns } from "./DeleteTableIcon.vue?vue&type=template&id=0741d6b8&scoped=true"
import script from "./DeleteTableIcon.vue?vue&type=script&lang=js"
export * from "./DeleteTableIcon.vue?vue&type=script&lang=js"
import style0 from "./DeleteTableIcon.vue?vue&type=style&index=0&id=0741d6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0741d6b8",
  null
  
)

export default component.exports